import React from "react";

type AddContactSectionProps = {
  title: string;
  description?: string;
  className?: string;
  children: React.ReactNode;
};

export const AddContactSection: React.FC<AddContactSectionProps> = ({
  title,
  description,
  className = "mt-5",
  children,
}) => {
  return (
    <div className={className}>
      <div className={"rounded-lg border border-gray-200 bg-gray-100 p-3"}>
        <div className={"mb-1 text-sm font-bold text-[#293B5A]"}>{title}</div>
        {description && (
          <div className={"mb-3 text-xs font-medium text-gray-400"}>
            {description}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
